<template>
  <section
    v-if="
      service.service_at_locations &&
      service.service_at_locations[0] &&
      service.service_at_locations[0].regular_schedule[0]
    "
    aria-role="region"
    aria-label="Session details"
    class="service-sessions border-top py-1"
  >
    <b-list-group
      v-for="(serviceLocation, locIx) in groupedByLocations"
      :key="locIx"
      class="service-sessions-meta mb-3"
    >
      <b-list-group-item class="session-date list-group-item p-0 border-0 small bg-transparent">
        <span v-if="serviceLocation.location.name">
          <strong>{{ serviceLocation.location.name }}:</strong>
        </span>
        <span v-else-if="address.address_1">{{ address.address_1 }}</span>
      </b-list-group-item>
      <span v-for="(regularSchedule, iX) in serviceLocation.schedule" :key="iX">
        <b-list-group-item
          v-for="(schedule, schedIx) in regularSchedule"
          :key="schedIx"
          class="session-date list-group-item p-0 border-0 small bg-transparent"
        >
          <span class="small mr-2"><b-icon icon="calendar3"></b-icon></span>
          <span class="meta-label">{{ schedule.freq }} - {{ schedule.description }}</span>
        </b-list-group-item>
      </span>
    </b-list-group>
  </section>
</template>

<script>
export default {
  name: 'ServiceTimes',
  props: {
    service: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    groupedByLocations() {
      let groupedByLocations = {}
      if (
        this.service.service_at_locations &&
        this.service.service_at_locations[0] &&
        this.service.service_at_locations[0].regular_schedule[0]
      ) {
        this.service.service_at_locations.forEach((session) => {
          if (!groupedByLocations[session.location.id]) {
            groupedByLocations[session.location.id] = {}
            groupedByLocations[session.location.id].schedule = []
            groupedByLocations[session.location.id].location = session.location
          }
          groupedByLocations[session.location.id].schedule.push(session.regular_schedule)
        })
      }
      return groupedByLocations
    },
  },
}
</script>
